import React, { useState, useEffect, Fragment } from "react";
import { useHistory } from "react-router-dom";

import Modal from "react-modal";
import moment from "moment";

import CloseIcon from "../../../assets/icons/close.svg";
import { ReactComponent as ArrowNextWhite } from "../../../assets/icons/arrowNextWhite.svg";
import { ReactComponent as Error } from "../../../assets/icons/error.svg";

import StyledRegister from "../../authentication/StyledRegister";
import { ReactComponent as Print } from "../../../assets/icons/print.svg";

import { App } from "../../../routes/Constants";
import QuitModal from "../../common/Modal/QuitModal";
import LocalStorage from "../../../shared/localStorage";
import APIVariables from "../../../services/api-variables";
import axios from "axios";
import { errorMessages } from "../../../constants/errorMessages.constants";
import { typeOfPAF } from "../../../constants/typeOfPAF";
import Footer from "../../common/Footer/Footer";
import Loader from "../../common/Loader/newLoader";

import DigitalPAF from "../PatientInitiation/DigitalPAF";
import {
  handleCatch,
  isDispensingMoreThan12WeeksBetween2Dates,
  isDispensingMoreThan3DaysBetween2Dates,
  isDispensingMoreThan7DaysBetween2Dates,
  verifyUserType,
} from "../../../shared/helpers";
import { registrationCategory } from "../../../constants/register.constants";
import HealthcareProfessionalInformationGuide from "../PatientMaterial/Brochures/PDFs/HealthcareProfessionalInformationGuide.pdf";
import PAFRenewModal from "./PAFRenewModal";
import InfoPAF from "../../common/InfoPAF/InfoPAF";
import ViewPAF from "../../common/ViewPAF/ViewPAF";

let customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "37%",
  },
};

const mediaMatch = window.matchMedia("(max-width: 850px)");
mediaMatch.matches === true
  ? (customStyles.content = { ...customStyles.content, width: "70%" })
  : (customStyles.content = {
      ...customStyles.content,
      width: "37%",
    });

const getLocalStorage = localStorage.getItem(LocalStorage.USER_IRELAND);
let parseLocalStorage = JSON.parse(getLocalStorage);

const PAFRenew = () => {
  const [showErrors, setShowErrors] = useState(false);
  const [personalDetails, setPersonalDetails] = useState({});
  const [resId, setResId] = useState(null);
  const [indications, setIndications] = useState([]);
  const [capsulePerCycle, setCapsulePerCycle] = useState([]);
  const [numberOfCycles, setNumberOfCycles] = useState([]);
  const [isSubmittedPresciberPAF, setIsSubmittedPrescriberPAF] =
    useState(false);
  const [registerModalIsOpen, setIsOpenRegister] = useState(false);
  const [pregnancyTestOutsideDateModal, setPregnancyTestOutsideDate] =
    useState(false);
  const [quitModalIsOpen, setIsOpenQuit] = useState(false);
  const [openRenewModal, setOpenRenewModal] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const [registerPatient, setRegisterPatient] = useState({ number_cycles: 1 });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [state, setState] = useState(4);
  const [disableCompleteButton, setDisableCompleteButton] = useState(false);
  const [isLoadingPage, setIsLoadingPage] = useState(false);

  const history = useHistory();

  const isPrescriber = verifyUserType(registrationCategory.PRESCRIBER);
  const typeOfForm = window.location.pathname.split("/")[3];
  const patientId = window.location.pathname.split("/")[4];

  useEffect(() => {
    setPersonalData();
    fetchData();

    getPatientDetails();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (indications.length && capsulePerCycle.length && numberOfCycles.length) {
      getPrescriptionForRenewal();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [indications, capsulePerCycle, numberOfCycles]);

  const getPatientDetails = async () => {
    setIsLoadingPage(true);
    const res = await axios
      .get(
        process.env.REACT_APP_BASE_URL +
          APIVariables.PATIENTS_DETAILS +
          patientId,
        {
          headers: {
            Authorization: parseLocalStorage.token,
          },
        }
      )
      .catch((error) => {
        handleCatch(error);
      });

    setIsLoadingPage(false);

    // Go back after creating/renewing a PAF, redirect the user to View PAF instead of the PAF Form
    if (
      res?.data?.prescriptions?.length &&
      res.data.prescriptions[res.data.prescriptions.length - 1].status_name ===
        "Submitted"
    ) {
      history.push(
        App.PRESCRIPTION_AUTHORISATION_FORM_DEFAULT +
          res.data.id +
          "/" +
          res.data.prescriptions[res.data.prescriptions.length - 1].id
      );
    }
  };

  const renameKeys = async (toBeRenamed, addNoneOption = false) => {
    await toBeRenamed.forEach((elem) => {
      elem["label"] = elem.value;
      elem["value"] = elem.id;
      delete elem["id"];
    });
    if (addNoneOption) {
      toBeRenamed.unshift({ label: "None", value: null });
    }
    return toBeRenamed;
  };

  const getPrescriptionForRenewal = async () => {
    const pafId = window.location.pathname.split("/")[5];
    const res = await axios
      .get(
        process.env.REACT_APP_BASE_URL + APIVariables.PRESCRIPTIONS + pafId,
        {
          headers: {
            Authorization: parseLocalStorage.token,
          },
        }
      )
      .catch((error) => {
        handleCatch(error);
      });

    if (res?.status === 200) {
      if (!!pafId) {
        handleData(res?.data);
      } else {
        //TODO treat the case when there is no paf
      }
    }
  };

  const handleData = (data) => {
    const { patient, prescriber } = data;
    let patient_type =
      patient?.patient_type === "Male"
        ? 0
        : patient?.patient_type === "Woman of Non-Childbearing Potential"
        ? 2
        : 1;
    let prescriber_name = prescriber?.first_name + " " + prescriber?.last_name;
    let patient_initial = patient.initial_name;
    let patient_dob = new Date(patient.dob);
    let name_and_address_hospital = prescriber?.name_and_address_hospital;
    let indication = indications.find(
      (indication) => indication.label === data?.indication
    );
    let high_tech_prescription_date =
      patient_type === typeOfPAF.WOMANOFCP
        ? null
        : new Date(data?.high_tech_prescription_date);
    let indication_other = data?.indication_other
      ? data?.indication_other
      : null;
    setRegisterPatient({
      ...registerPatient,
      patient_type,
      patient_initial,
      patient_dob,
      high_tech_prescription_date,
      indication,
      name_and_address_hospital,
      prescriber_name,
      indication_other,
      pharmacy_address: data?.pharmacy_address,
    });
  };

  async function fetchData() {
    let dropDownValues;

    dropDownValues = await axios
      .get(
        process.env.REACT_APP_BASE_URL +
          (APIVariables.PRESCRIPTIONS +
            patientId +
            APIVariables.PRESCRIPTIONS_RENEW),
        {
          headers: {
            Authorization: parseLocalStorage.token,
          },
        }
      )
      .catch((error) => {
        handleCatch(error);
      });

    const { indication, capsule_cycle, n_cycles } = await dropDownValues?.data;
    setIndications(await renameKeys(indication, true));
    setCapsulePerCycle(await renameKeys(capsule_cycle, true));
    setNumberOfCycles(await renameKeys(n_cycles, true));
  }

  const setPersonalData = () => {
    const composedUserDetails = {
      ...parseLocalStorage,
      hospital_name: parseLocalStorage?.hospital?.name,
      hospital_address: parseLocalStorage?.hospital?.address?.full_address,
    };
    setPersonalDetails(composedUserDetails);
  };

  const submitPAFToServer = async () => {
    setDisableCompleteButton(true);
    await submitForm();
    setDisableCompleteButton(false);
  };

  const nextPage = async () => {
    setShowErrors(false);
    if (state === 6) {
      setIsSubmittedPrescriberPAF(false);
      if (!areAllFieldsValid) {
        setShowErrors(true);
        return;
      } else {
        setIsOpenRegister(true);
      }
    }
    if (state === 4) {
      if (!areAllFieldsValid) {
        setShowErrors(true);
        return;
      }
      if (
        !pregnancyTestOutsideDateModal &&
        typeOfPAF.WOMANOFCP === registerPatient.patient_type &&
        isDispensingMoreThan3DaysBetween2Dates(
          registerPatient.high_tech_prescription_date,
          registerPatient.patient_pregnancy_test
        )
      ) {
        openModalPregnancyError();
        return;
      }
      setState(state + 2);
    }
  };

  const previous = () => {
    setState(state - 2);
  };

  const updateRegisterPatient = (field, value) => {
    setRegisterPatient((prevState) => ({
      ...prevState,
      [field]: value,
    }));
  };

  const handleCloseRenewModal = () => {
    setOpenRenewModal(false);
  };

  const getTextForRenew = () => {
    switch (parseInt(typeOfForm)) {
      case typeOfPAF.MALE:
        return {
          message:
            "The PAF selected is for a male patient. If you wish to renew this PAF, please continue, otherwise, click cancel.",
          title: "Male Patient Renewal",
        };
      case typeOfPAF.WOMANOFCP:
        return {
          message:
            "The PAF selected is for a woman of childbearing potential. If you wish to renew this PAF, please continue, otherwise, click cancel.",
          title: "Woman of Childbearing Potential Renewal",
        };
      case typeOfPAF.WOMANOFNCP:
        return {
          message:
            "The PAF selected is for a woman of non-childbearing potential. If you wish to renew this PAF, please continue, otherwise, click cancel.",
          title: "Woman of Non-Childbearing Potential Renewal",
        };
      default:
        return {};
    }
  };

  const handleChange = (e) => {
    let { name, value, maxLength } = e.target;

    if (name.toLowerCase().includes("capsule_cycle_other")) {
      if (+value <= 0) {
        value = "1";
      } else if (+value > 200) {
        value = "200";
      }
    }

    const shouldSetValue = +value.length <= maxLength;

    let filterValue = value;

    const nameRegex = /[^a-zA-Z -]/g;

    if (name === "prescriber_name" || name === "patient_initial") {
      if (value === "" || nameRegex.test(e.target.value)) {
        filterValue = filterValue.replace(nameRegex, "");
      }
    }

    if (name === "patient_initial") {
      filterValue = filterValue?.toUpperCase();
    }

    const formCopy = {
      ...registerPatient,
      [name]: filterValue,
    };

    if (maxLength === -1) {
      setRegisterPatient(formCopy);
    } else {
      if (shouldSetValue) {
        setRegisterPatient(formCopy);
      }
    }

    setTotalCapsules(formCopy);
  };

  const handleChangeCheckBox = (e) => {
    const { name, checked } = e.target;

    setRegisterPatient((prevState) => ({
      ...prevState,
      [name]: checked,
    }));
  };

  const redirectToOrderPage = () => {
    history.push(App.VIEW_PATIENTS);
  };

  const closeModalRegisterModal = () => {
    setIsOpenRegister(false);
  };

  const disableNextButton = () => {
    if (state === 4) {
      return;
    }
  };

  function closeModalQuit() {
    setIsOpenQuit(false);
  }

  function quitModal() {
    history.push(App.DASHBOARD);
  }

  function closeForm() {
    setIsOpenQuit(true);
  }

  function formatDateWithDash(date) {
    return moment(date).format("YYYY-MM-DD");
  }

  const submitForm = async () => {
    return new Promise(async (response) => {
      setErrorMessage("");
      setIsSubmitting(true);

      const getLocalStorage = localStorage.getItem(LocalStorage.USER_IRELAND);
      const parseLocalStorage = JSON.parse(getLocalStorage);

      let copyOfRegisterPatient = Object.assign({}, registerPatient);

      copyOfRegisterPatient.patient_dob = formatDateWithDash(
        copyOfRegisterPatient.patient_dob
      );

      copyOfRegisterPatient.high_tech_prescription_date = formatDateWithDash(
        copyOfRegisterPatient.high_tech_prescription_date
      );

      copyOfRegisterPatient.patient_pregnancy_test = formatDateWithDash(
        copyOfRegisterPatient.patient_pregnancy_test
      );

      copyOfRegisterPatient.indication = copyOfRegisterPatient.indication.value;

      copyOfRegisterPatient.capsule_cycle_5 =
        copyOfRegisterPatient?.capsule_per_cycle_5?.value;
      delete copyOfRegisterPatient.capsule_per_cycle_5;

      copyOfRegisterPatient.capsule_cycle_10 =
        copyOfRegisterPatient?.capsule_per_cycle_10?.value;
      delete copyOfRegisterPatient.capsule_per_cycle_10;

      copyOfRegisterPatient.capsule_cycle_15 =
        copyOfRegisterPatient?.capsule_per_cycle_15?.value;
      delete copyOfRegisterPatient.capsule_per_cycle_15;

      copyOfRegisterPatient.capsule_cycle_20 =
        copyOfRegisterPatient?.capsule_per_cycle_20?.value;
      delete copyOfRegisterPatient.capsule_per_cycle_20;

      copyOfRegisterPatient.capsule_cycle_25 =
        copyOfRegisterPatient?.capsule_per_cycle_25?.value;
      delete copyOfRegisterPatient.capsule_per_cycle_25;

      copyOfRegisterPatient.n_cycles =
        copyOfRegisterPatient.patient_type === typeOfPAF.WOMANOFCP
          ? "1"
          : copyOfRegisterPatient.number_cycles.value;
      delete copyOfRegisterPatient.number_cycles;

      copyOfRegisterPatient.confirmation_other1 = true;

      copyOfRegisterPatient.confirmation_other2 =
        copyOfRegisterPatient.patient_type === 2
          ? true
          : copyOfRegisterPatient.confirmation_has_been_conselled;
      delete copyOfRegisterPatient.confirmation_has_been_conselled;

      if (copyOfRegisterPatient?.capsule_cycle_other_5?.length === 0)
        delete copyOfRegisterPatient.capsule_cycle_other_5;
      if (copyOfRegisterPatient?.capsule_cycle_other_10?.length === 0)
        delete copyOfRegisterPatient.capsule_cycle_other_10;
      if (copyOfRegisterPatient?.capsule_cycle_other_15?.length === 0)
        delete copyOfRegisterPatient.capsule_cycle_other_15;
      if (copyOfRegisterPatient?.capsule_cycle_other_20?.length === 0)
        delete copyOfRegisterPatient.capsule_cycle_other_20;
      if (copyOfRegisterPatient?.capsule_cycle_other_25?.length === 0)
        delete copyOfRegisterPatient.capsule_cycle_other_25;

      if (
        copyOfRegisterPatient.patient_type === typeOfPAF.MALE ||
        copyOfRegisterPatient.patient_type === typeOfPAF.WOMANOFNCP
      ) {
        delete copyOfRegisterPatient.patient_pregnancy_test;
      }

      delete copyOfRegisterPatient.name_and_address_hospital;

      const res = await axios
        .post(
          process.env.REACT_APP_BASE_URL +
            APIVariables.PRESCRIPTIONS +
            `${patientId}` +
            APIVariables.PRESCRIPTIONS_RENEW,
          copyOfRegisterPatient,
          {
            headers: {
              Authorization: parseLocalStorage.token,
            },
          }
        )
        .catch(function (error) {
          setIsSubmitting(false);
          handleCatch(error);

          const errors = error.response.data;
          const errorsArray = [];
          if (typeof errors === "string") {
            errorsArray.push(errorMessages.INTERNAL_SERVER_ERROR);
          } else {
            Object.keys(errors).forEach((key) => {
              errorsArray.push(key + " - " + errors[key]);
            });
          }
          setErrorMessage(errorsArray);
          return response(errorsArray);
        });

      if (res?.status === 200) {
        setIsSubmitting(false);
        setIsSubmittedPrescriberPAF(true);
        setResId(res.data?.id);
        return response(true);
      }
      setIsSubmitting(false);
    });
  };

  function closeModalPregnancyError() {
    setPregnancyTestOutsideDate(false);
  }

  function openModalPregnancyError() {
    setPregnancyTestOutsideDate(true);
  }

  const handleChangeSelect = (selectedElement, name) => {
    const formCopy = {
      ...registerPatient,
      [name]: selectedElement,
      ...(name === "capsule_per_cycle_5" &&
        selectedElement.value !== 0 && { capsule_cycle_other_5: "" }),
      ...(name === "capsule_per_cycle_10" &&
        selectedElement.value !== 0 && { capsule_cycle_other_10: "" }),
      ...(name === "capsule_per_cycle_15" &&
        selectedElement.value !== 0 && { capsule_cycle_other_15: "" }),
      ...(name === "capsule_per_cycle_20" &&
        selectedElement.value !== 0 && { capsule_cycle_other_20: "" }),
      ...(name === "capsule_per_cycle_25" &&
        selectedElement.value !== 0 && { capsule_cycle_other_25: "" }),
    };
    if (selectedElement.value === null) {
      formCopy[name] = {
        label: "Select",
        value: name === "number_cycles" ? 0 : null,
      };
    }
    setRegisterPatient(formCopy);

    setTotalCapsules(formCopy);
  };

  const removeEmptyValueAndSelectLabel = (form) => {
    Object.keys(form)?.forEach((key) => {
      if (form[key] === "" || form[key]?.label === "Select") {
        delete form[key];
      }
    });
    return form;
  };

  const setTotalCapsules = (formCopy) => {
    const {
      capsule_per_cycle_5,
      capsule_per_cycle_10,
      capsule_per_cycle_15,
      capsule_per_cycle_20,
      capsule_per_cycle_25,
      capsule_cycle_other_5,
      capsule_cycle_other_10,
      capsule_cycle_other_15,
      capsule_cycle_other_20,
      capsule_cycle_other_25,
      number_cycles,
    } = formCopy;

    const totalCapsulesPerCycle =
      (!!capsule_per_cycle_5
        ? capsule_per_cycle_5.value === 0
          ? +capsule_cycle_other_5 || 0
          : capsule_per_cycle_5.value
        : 0) +
      (!!capsule_per_cycle_10
        ? capsule_per_cycle_10.value === 0
          ? +capsule_cycle_other_10 || 0
          : capsule_per_cycle_10.value
        : 0) +
      (!!capsule_per_cycle_15
        ? capsule_per_cycle_15.value === 0
          ? +capsule_cycle_other_15 || 0
          : capsule_per_cycle_15.value
        : 0) +
      (!!capsule_per_cycle_20
        ? capsule_per_cycle_20.value === 0
          ? +capsule_cycle_other_20 || 0
          : capsule_per_cycle_20.value
        : 0) +
      (!!capsule_per_cycle_25
        ? capsule_per_cycle_25.value === 0
          ? +capsule_cycle_other_25 || 0
          : capsule_per_cycle_25.value
        : 0);

    const totalCapsulesStrengts =
      (!!capsule_per_cycle_5 ? 5 : 0) +
      (!!capsule_per_cycle_10 ? 10 : 0) +
      (!!capsule_per_cycle_15 ? 15 : 0) +
      (!!capsule_per_cycle_20 ? 20 : 0) +
      (!!capsule_per_cycle_25 ? 25 : 0);

    const numberOfCyles = !isNaN(number_cycles)
      ? number_cycles
      : number_cycles.value;

    const totalCapsules = +totalCapsulesPerCycle * numberOfCyles;

    setRegisterPatient((prevState) => ({
      ...prevState,
      total_capsules: totalCapsules,
      capsule_strength: totalCapsulesStrengts,
    }));
  };

  const {
    high_tech_prescription_date,
    patient_initial,
    patient_dob,
    indication,
    indication_other,
    capsule_per_cycle_5,
    capsule_per_cycle_10,
    capsule_per_cycle_15,
    capsule_per_cycle_20,
    capsule_per_cycle_25,
    capsule_cycle_other_5,
    capsule_cycle_other_10,
    capsule_cycle_other_15,
    capsule_cycle_other_20,
    capsule_cycle_other_25,
    number_cycles,
    // Pharmacy
    prescriber_name,
    name_and_address_hospital,
    date_paper_paf,
    patient_pregnancy_test,
    confirmation_other1,
    confirmation_other2,
    confirmation_other3,
    confirmation_has_been_conselled,
  } = registerPatient;

  // START VALIDED MALE FORM
  const validateFields = ({
    high_tech_prescription_date = "",
    patient_initial = "",
    patient_dob = "",
    indication = "",
    indication_other = "",
    capsule_per_cycle_5 = "",
    capsule_per_cycle_10 = "",
    capsule_per_cycle_15 = "",
    capsule_per_cycle_20 = "",
    capsule_per_cycle_25 = "",
    capsule_cycle_other_5 = "",
    capsule_cycle_other_10 = "",
    capsule_cycle_other_15 = "",
    capsule_cycle_other_20 = "",
    capsule_cycle_other_25 = "",
    number_cycles = "",
    // Pharmacy
    patient_pregnancy_test = "",
    confirmation_other3 = "",
    confirmation_has_been_conselled = "",
  }) => ({
    high_tech_prescription_date: {
      isValid: !!high_tech_prescription_date,
    },
    high_tech_prescription_date_interval: {
      isValid:
        registerPatient.patient_type === typeOfPAF.WOMANOFCP
          ? isDispensingMoreThan7DaysBetween2Dates(
              high_tech_prescription_date,
              moment().toDate()
            )
          : isDispensingMoreThan12WeeksBetween2Dates(
              high_tech_prescription_date,
              moment().toDate()
            ),
    },
    patient_initial: {
      isValid: patient_initial.trim().length > 0,
    },
    patient_dob: {
      isValid: !!patient_dob,
    },
    indication: {
      isValid:
        indication?.label?.trim().length >= 0 &&
        !(indication?.label === "Select"),
    },
    indication_other: {
      isValid: !indication?.label?.includes("Other")
        ? true
        : indication_other?.trim().length > 0,
    },
    number_cycles: {
      isValid:
        registerPatient.patient_type !== typeOfPAF.WOMANOFCP
          ? number_cycles?.label?.trim().length >= 0 &&
            !(number_cycles.label === "Select")
          : true,
    },
    capsule_per_cycle: {
      isValid:
        (capsule_per_cycle_5.label?.trim().length >= 0 &&
          !(capsule_per_cycle_5.label === "Select")) ||
        (capsule_per_cycle_10.label?.trim().length >= 0 &&
          !(capsule_per_cycle_10.label === "Select")) ||
        (capsule_per_cycle_15.label?.trim().length >= 0 &&
          !(capsule_per_cycle_15.label === "Select")) ||
        (capsule_per_cycle_20.label?.trim().length >= 0 &&
          !(capsule_per_cycle_20.label === "Select")) ||
        (capsule_per_cycle_25.label?.trim().length >= 0 &&
          !(capsule_per_cycle_25.label === "Select")),
    },
    capsule_cycle_other_5: {
      isValid:
        capsule_per_cycle_5?.value === 0
          ? capsule_cycle_other_5.trim().length > 0
          : true,
    },
    capsule_cycle_other_10: {
      isValid:
        capsule_per_cycle_10?.value === 0
          ? capsule_cycle_other_10.trim().length > 0
          : true,
    },
    capsule_cycle_other_15: {
      isValid:
        capsule_per_cycle_15?.value === 0
          ? capsule_cycle_other_15.trim().length > 0
          : true,
    },
    capsule_cycle_other_20: {
      isValid:
        capsule_per_cycle_20?.value === 0
          ? capsule_cycle_other_20.trim().length > 0
          : true,
    },
    capsule_cycle_other_25: {
      isValid:
        capsule_per_cycle_25?.value === 0
          ? capsule_cycle_other_25.trim().length > 0
          : true,
    },
    prescriber_name: {
      isValid: true,
    },
    name_and_address_hospital: {
      isValid: true,
    },
    date_paper_paf: {
      isValid: true,
    },
    patient_pregnancy_test: {
      isValid:
        registerPatient.patient_type === typeOfPAF.WOMANOFCP
          ? !!patient_pregnancy_test
          : true,
    },
    confirmation_other1: {
      isValid: true,
    },
    confirmation_other2: {
      isValid: true,
    },
    confirmation_other3: {
      isValid: !!confirmation_other3,
    },
    confirmation_has_been_conselled: {
      isValid:
        registerPatient.patient_type === typeOfPAF.WOMANOFNCP
          ? true
          : !!confirmation_has_been_conselled,
    },
  });

  let areAllFieldsValid;

  const fields = validateFields({
    high_tech_prescription_date,
    patient_initial,
    patient_dob,
    indication,
    indication_other,
    capsule_per_cycle_5,
    capsule_per_cycle_10,
    capsule_per_cycle_15,
    capsule_per_cycle_20,
    capsule_per_cycle_25,
    capsule_cycle_other_5,
    capsule_cycle_other_10,
    capsule_cycle_other_15,
    capsule_cycle_other_20,
    capsule_cycle_other_25,
    number_cycles,
    // Pharmacy
    prescriber_name,
    name_and_address_hospital,
    date_paper_paf,
    patient_pregnancy_test,
    confirmation_other1,
    confirmation_other2,
    confirmation_other3,
    confirmation_has_been_conselled,
  });

  areAllFieldsValid = Object.values(fields).every((field) => {
    return field.isValid;
  });

  const userInfo = {
    initial_name: registerPatient.patient_initial,
    gender: registerPatient.patient_type === typeOfPAF.MALE ? "Male" : "Female",
    dob: registerPatient.patient_dob,
    hospital:
      parseLocalStorage?.hospital?.name +
      ", " +
      parseLocalStorage?.hospital?.address?.full_address,
  };

  const printPAF = async () => {
    axios
      .get(process.env.REACT_APP_BASE_URL + APIVariables.DOWNLOAD_PAF + resId, {
        headers: {
          Authorization: parseLocalStorage.token,
        },
      })
      .then((response) => {
        return response.data.report;
      })
      .then(async function (base64) {
        const base64Pdf = await fetch(`data:application/pdf;base64,${base64}`);
        return base64Pdf.blob();
      })
      .then((blob) => {
        const file = new Blob([blob], {
          type: "application/pdf",
        });
        const fileURL = URL.createObjectURL(file);
        const downloadLink = document.createElement("a");
        downloadLink.href = fileURL;
        downloadLink.download = `PAF.pdf`;
        downloadLink.click();
        downloadLink.remove();
        URL.revokeObjectURL(downloadLink.href);
      })
      .catch((error) => {
        handleCatch(error);
      });
  };

  const commonFormProps = {
    state,
    previous,
    handleChange,
    registerPatient,
    personalDetails,
    handleChangeCheckBox,
    validateFields: fields,
    updateRegisterPatient,
    errorMessage,
    showErrors,
    handleChangeSelect,
    indications,
    capsulePerCycle,
    numberOfCycles,
  };

  if (isLoadingPage) return <Loader />;

  return (
    <Fragment>
      <StyledRegister>
        <div className="layout-modal">
          <div className="close-icon" onClick={closeForm}>
            <img src={CloseIcon} alt="Close Icon" />
          </div>
          <div>
            {state === 4 && (
              <DigitalPAF
                {...commonFormProps}
                parseLocalStorage={parseLocalStorage}
                isRenewal={true}
              />
            )}
            {state === 6 && (
              <Fragment>
                <div className="wrapper-flex">
                  <h1>Prescription Authorization Form</h1>
                  {!registerModalIsOpen && (
                    <>
                      {!isSubmittedPresciberPAF ? (
                        <div className="approve-reject-paf">
                          <button
                            className="mr-4 cancel-btn"
                            onClick={previous}
                          >
                            Cancel
                          </button>
                          <button
                            className="green-button"
                            onClick={nextPage}
                            disabled={disableCompleteButton}
                          >
                            Complete
                            <ArrowNextWhite />
                          </button>
                        </div>
                      ) : (
                        <div className="approve-reject-paf">
                          <button
                            className="mr-4 cancel-btn"
                            onClick={() => printPAF()}
                          >
                            Print <Print />
                          </button>
                          <button
                            className="green-button"
                            onClick={redirectToOrderPage}
                          >
                            Finish
                          </button>
                        </div>
                      )}
                    </>
                  )}
                </div>

                <InfoPAF
                  patientDetails={userInfo}
                  registerPatient={registerPatient}
                  isRenewal
                />
                <ViewPAF
                  form={removeEmptyValueAndSelectLabel(registerPatient)}
                  isPrescriber={isPrescriber}
                  personalDetails={personalDetails}
                  isRenewal={true}
                />
              </Fragment>
            )}
          </div>
          <div>
            <div className={"wrapper-buttons-select-type"}>
              {state <= 6 && state >= 4 ? (
                <div />
              ) : (
                <button onClick={previous} className="prev">
                  Previous
                </button>
              )}
              <div className="flex-between-center">
                {state === 4 && (
                  <div className="symbol-idication">
                    *symbol indicating a mandatory field
                  </div>
                )}
                {state === 4 && (
                  <button
                    className="primary-button custom-login-button"
                    onClick={nextPage}
                    disabled={isSubmitting || disableNextButton()}
                  >
                    {"Next"}
                    {isSubmitting ? (
                      <i className="custom-login-loader">
                        <Loader />
                      </i>
                    ) : (
                      <ArrowNextWhite className="custom-login-arrow" />
                    )}
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>

        <Modal
          isOpen={registerModalIsOpen}
          style={customStyles}
          contentLabel="Register Modal"
          overlayClassName="overlay-modal"
          shouldCloseOnOverlayClick={false} // add this to prevent outside click to prevent modal close
        >
          <div className="wrapper-modal">
            <div className="main-text">
              Prescription Authorization Form Completed
            </div>
            <div className="second-text">
              A copy of the prescription authorisation form will be available to
              the nominated community pharmacy.
            </div>
          </div>
          <div className="wrapper-buttons">
            <button className="cancel mr-6" onClick={closeModalRegisterModal}>
              Cancel
            </button>
            <button
              className="green-button"
              onClick={() => {
                submitPAFToServer();
                closeModalRegisterModal();
              }}
            >
              Complete <ArrowNextWhite />
            </button>
          </div>
        </Modal>

        {quitModalIsOpen && (
          <QuitModal
            quitModalIsOpen={quitModalIsOpen}
            closeModalQuit={closeModalQuit}
            quitModal={quitModal}
            description="Are you sure you want to cancel filling out this Treatment Initiation Form. All progress will be lost and you will need to start again."
          />
        )}

        <Modal
          isOpen={pregnancyTestOutsideDateModal}
          onRequestClose={openModalPregnancyError}
          style={customStyles}
          contentLabel="Pregnancy Test Outdated"
          overlayClassName="overlay-modal"
          shouldCloseOnOverlayClick={false} // add this to prevent outside click to prevent modal close
        >
          <button
            onClick={closeModalPregnancyError}
            className="close-icon-button "
          >
            <img src={CloseIcon} alt="Close Icon" />
          </button>
          <div className="wrapper-modal">
            <div className="image">{<Error />}</div>
            <div className="main-text-error">
              {errorMessages.OUTDATED_PREGANACY_TEST_TITLE}
            </div>
            <div className="second-text">
              <div>
                A valid negative pregnancy test must have been conducted a
                maximum of 3 days prior to the prescription date. Please refer
                to the SmPC and{" "}
                <a
                  rel="noreferrer"
                  href={HealthcareProfessionalInformationGuide}
                  target="_blank"
                >
                  Healthcare Professional Information Guide
                </a>{" "}
                for further information on pregnancy prevention measures.
              </div>
            </div>
          </div>
          <div className="wrapper-buttons">
            <button className="red-button" onClick={closeModalPregnancyError}>
              Re-enter <ArrowNextWhite />
            </button>
          </div>
        </Modal>

        <PAFRenewModal
          openModal={openRenewModal}
          closeModal={handleCloseRenewModal}
          text={getTextForRenew()}
        />
      </StyledRegister>
      <Footer />
    </Fragment>
  );
};
export default PAFRenew;
